// Copy of this file is in links project

const pricingList = {
  free: {
    monthlyPrice: 0,
    yearlyPrice: 0,
    forms: 2,
    responses: false,
    customSeo: false,
    customLink: false,
    removeBranding: false,
    fileUpload: false,
    advancedFields: false,
    multiAgent: false,
    integrations: false,
    customDomain: false,
    conditionalLogic: false,
    maxUploadStorage: 0, // in MB
    maxResponseCount: 0,
  },
  lite: {
    monthlyPrice: 12,
    yearlyPrice: 9,
    forms: 10,
    responses: true,
    customSeo: true,
    customLink: false,
    removeBranding: false,
    fileUpload: false,
    advancedFields: false,
    multiAgent: false,
    integrations: false,
    customDomain: false,
    conditionalLogic: false,
    maxUploadStorage: 0, // in MB
    maxResponseCount: 5000,
  },
  standard: {
    monthlyPrice: 24,
    yearlyPrice: 18,
    forms: 25,
    responses: true,
    customSeo: true,
    customLink: true,
    removeBranding: true,
    fileUpload: true,
    advancedFields: true,
    multiAgent: true,
    integrations: true,
    customDomain: true,
    conditionalLogic: true,
    maxUploadStorage: 10000, // in MB
    maxResponseCount: 25000,
  },
  pro: {
    monthlyPrice: 24,
    yearlyPrice: 18,
    forms: 25,
    responses: true,
    customSeo: true,
    customLink: true,
    removeBranding: true,
    fileUpload: true,
    advancedFields: true,
    multiAgent: true,
    integrations: true,
    customDomain: true,
    conditionalLogic: true,
    maxUploadStorage: 100000, // in MB
    maxResponseCount: 100000,
  },
  plus: {
    monthlyPrice: 49,
    yearlyPrice: 36,
    forms: 50,
    responses: true,
    customSeo: true,
    customLink: true,
    removeBranding: true,
    fileUpload: true,
    advancedFields: true,
    multiAgent: true,
    integrations: true,
    customDomain: true,
    conditionalLogic: true,
    maxUploadStorage: 100000, // in MB
    maxResponseCount: 100000,
  },
};

export const getPrice = (plan, cycle) => {
  const cycleName = cycle === 'monthly' ? 'monthlyPrice' : 'yearlyPrice';
  if (!pricingList[plan]) plan = 'free';
  return pricingList[plan][cycleName] ? pricingList[plan][cycleName] : 0;
};

export const hasFeature = (plan, feature) => {
  if (!plan) plan = 'free';
  if (!pricingList[plan]) plan = 'free';
  return pricingList[plan][feature] ? pricingList[plan][feature] : false;
};

export const getFormLimit = (plan, maxFormCount) => {
  if (!plan) plan = 'free';
  if (!pricingList[plan]) plan = 'free';
  return maxFormCount || pricingList[plan]['forms'];
};

export const getMaxUploadStorage = (plan) => {
  if (!plan) plan = 'free';
  if (!pricingList[plan]) plan = 'free';
  return pricingList[plan]['maxUploadStorage'];
};

export const getMaxResponseCount = (plan) => {
  if (!plan) plan = 'free';
  if (!pricingList[plan]) plan = 'free';
  return pricingList[plan]['maxResponseCount'];
};
